export class FindAllPagesErrorEffect {
  public static readonly type = '[Project/Wiki/List] FindAllPagesErrorEffect';
  constructor(public readonly error: Error) {}
}
